document.documentElement.classList.remove('no-js');
document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const option = select.options[select.selectedIndex];
  const scope = form.closest('.card, .product-details') || form.parentElement;
  const price = scope.querySelector('[data-card-price], [data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
